module.exports = __webpack_public_path__ + "static/media/payment.ec6101ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/payment.png
// module id = 1543
// module chunks = 0